// extracted by css-extract-rspack-plugin
export default {"cls1":"Upsell-cls1_fc0","cls2":"Upsell-cls2_PeH Upsell-cls1_fc0"};